import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { ModeratorService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Moderators extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Item',
			'Nombre',
			'Email',
			'Teléfono',
			'Ciudad',
			'Cédula',
			'Opciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		delete_reasons: [],
		reason_id: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Administradores',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await ModeratorService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.users?.rows?.map((item: any, index: number) => {
				item._index = (this.state.page - 1) * Constants.PER_PAGE + (index + 1)
				return item;
			}) || [],
			last_page: res.users?.count || 1,
			delete_reasons: res.delete_reasons || []
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	delete = async () => {
		if (!this.state.reason_id) {
			Globals.showError("Por favor, seleccione un motivo de eliminación");
			return;
		}
		await ModeratorService.delete({
			// @ts-ignore
			_user_id: this.state.item?.id,
			reason_id: this.state.reason_id
		});
		this.setState({
			visible: false,
			item: null,
			reason_id: null
		},() => {
			this.load(true);
		});
	}

	openModalDelete = (item: any) => {
		this.setState({
			visible: true,
			item
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		});
	}

	render() {
		const { visible } = this.state;
		const { delete_reasons } = this.state;

		return (
			<div id="moderators">
				<Modal
		          className="modal-delete-moderator"
		          visible={ visible }
		          title="Eliminar administrador"
		          onClose={ () => this.onClose() }
		        >
		        	<div id="modal-delete-moderator">
			        	{
			        		delete_reasons?.map((item: any) => {
			        			return (
			        				<div className="container-item" onClick={ () => this.setState({ reason_id: item?.id }) }>
			        					<div className={ `check ${ this.state.reason_id == item?.id ? 'active' : '' }` }></div>
			        					<p>{ item?.name }</p>
			        				</div>
			        			)
			        		})
			        	}
			        	<div className="text-center">
			        		<button className="btn btn-blue" onClick={ () => this.delete() }>
								Eliminar
							</button>
			        	</div>
			        </div>
		      	</Modal>

				<div className="row row-white">
					<div className="col-md-6">
						<p className="title-white">Administradores</p>
					</div>
					<div className="col-md-6">
						<div className="container-add">
							<Input
								value={ this.state.form.search }
								name="search"
								placeholder="Buscar"
								className="input-table"
								notMui
								searchRight
								onChange={ (e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.load(true);
									},1000);
									this.change(e); 
								} } />
							<button className="btn" onClick={ () => this.props.history.push(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/moderators/create`) }>
								<p>Registrar administrador</p>
								<div className="add">
									+
								</div>
							</button>
						</div>
					</div>
				</div>

				<Table title="Administradores" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i._index }</td>
								<td>{ i.name }</td>
								<td>{ i.email }</td>
								<td>{ i.phone }</td>
								<td>{ i.city }</td>
								<td>{ i.nationality?.code }{ i.document }</td>
								<td>
									<button className="btn btn-update" onClick={ () => this.props.history.push(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/moderators/create/` + i.id) }>
										Editar
									</button>
									<button className="btn btn-delete" onClick={ () => this.openModalDelete(i) }>
										Eliminar
									</button>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Moderators);